const ENV_VAR_KEY = /^[A-Z0-9_]+$/;

export const envVarKeysOf = (configKeys) =>
  (configKeys || []).filter((key) => ENV_VAR_KEY.test(key || ""));
